import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft, faChevronRight, faExclamationCircle, faExclamationTriangle, faInfoCircle, faTimes, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import {} from "@/api/schema";
import { useMarkdown } from "@/composables/markdown";
import { useBroadcastsStore } from "@/stores/broadcastsStore";
import { ensureDefined } from "@/utils/assertions";
import { match } from "@/utils/utils";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BroadcastContainer',
    props: {
        options: null
    },
    setup(__props) {
        const props = __props;
        library.add(faInfoCircle, faTimes, faChevronRight, faChevronLeft, faExclamationTriangle, faExclamationCircle);
        const broadcastsStore = useBroadcastsStore();
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true });
        const multiple = computed(() => {
            if (props.options.previewMode) {
                return false;
            }
            else {
                return props.options.broadcasts.length > 1;
            }
        });
        const page = ref(0);
        const currentPage = computed({
            get: () => {
                return page.value;
            },
            set: (newPage) => {
                page.value = newPage;
                checkPageInBounds();
            },
        });
        function checkPageInBounds() {
            if (page.value < 0) {
                page.value = sortedBroadcasts.value.length - 1;
            }
            else if (page.value >= sortedBroadcasts.value.length) {
                page.value = 0;
            }
        }
        const displayedBroadcast = computed(() => ensureDefined(sortedBroadcasts.value[currentPage.value]));
        function sortByImportanceAndPublicationTime(a, b) {
            const priority = (v) => match(v, {
                info: () => 0,
                warning: () => 1,
                urgent: () => 2,
            });
            const priorityA = priority(a.variant);
            const priorityB = priority(b.variant);
            if (priorityA !== priorityB) {
                return priorityB - priorityA;
            }
            else {
                return new Date(b.publication_time).getTime() - new Date(a.publication_time).getTime();
            }
        }
        const sortedBroadcasts = computed(() => {
            if (props.options.previewMode) {
                return [props.options.broadcast];
            }
            else {
                const sorted = [...props.options.broadcasts];
                sorted.sort(sortByImportanceAndPublicationTime);
                return sorted;
            }
        });
        watch(() => sortedBroadcasts.value, () => {
            checkPageInBounds();
        });
        function actionLinkBind(link) {
            if (link.startsWith("/")) {
                return {
                    to: link,
                };
            }
            else {
                return {
                    href: link,
                };
            }
        }
        function dismiss() {
            if (!props.options.previewMode) {
                broadcastsStore.dismissBroadcast(displayedBroadcast.value);
            }
        }
        return { __sfc: true, props, broadcastsStore, renderMarkdown, multiple, page, currentPage, checkPageInBounds, displayedBroadcast, sortByImportanceAndPublicationTime, sortedBroadcasts, actionLinkBind, dismiss, FontAwesomeIcon, BButton, Heading };
    }
});
